import React from "react";
import { Field, useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Fade from "@mui/material/Fade";
import { FormControlLabel, Radio } from "@mui/material";
import { RadioGroup } from "formik-mui";


export const PostExposureSurvey = ({ questionTypes = {} } = {}) => {
  const { values, handleChange, errors, touched, isSubmitting } = useFormikContext();

  return (
    <Grid container spacing={3}>
      <Grid container wrap="nowrap" item xs={12}>
        <Typography variant="h6" component={"span"}>
          Post exposure survey
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Field
          value={values.include_external_survey}
          component={RadioGroup}
          name="include_external_survey"
        >
          <FormControlLabel
            checked={values.include_external_survey === "0"}
            value={0}
            control={<Radio disabled={isSubmitting} color="primary" />}
            label="I would not like to include a post-exposure survey"
            disabled={isSubmitting}
          />
          <FormControlLabel
            checked={values.include_external_survey === "1"}
            value={1}
            control={<Radio disabled={isSubmitting} color="primary" />}
            label="I would like to include my own post-exposure survey"
            disabled={isSubmitting}
          />
          <FormHelperText error>
            {touched["include_external_survey"] && !!errors["include_external_survey"]
              ? errors["include_external_survey"]
              : ""}
          </FormHelperText>
        </Field>
      </Grid>

      <Fade mountOnEnter unmountOnExit in={values.include_external_survey === "1"}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            Please enter the URL of your post-exposure survey in the text underneath
          </Typography>
        </Grid>
      </Fade>

      <Fade mountOnEnter unmountOnExit in={values.include_external_survey === "1"}>
        <Grid container wrap="nowrap" item xs={12}>
          <TextField
            fullWidth
            name="external_survey_step_url"
            label="Post exposure survey URL"
            variant="filled"
            value={values.external_survey_step_url}
            onChange={handleChange}
            error={touched["external_survey_step_url"] && !!errors["external_survey_step_url"]}
            helperText={
              touched["external_survey_step_url"] && !!errors["external_survey_step_url"]
                ? errors["external_survey_step_url"]
                : ""
            }
          />
        </Grid>
      </Fade>

      <Fade mountOnEnter unmountOnExit in={values.include_external_survey === "1"}>
        <Grid container wrap="nowrap" item xs={12}>
          <TextField
            fullWidth
            name="external_survey_step_insert_parameter"
            label="Post exposure survey insert parameter"
            variant="filled"
            value={values.external_survey_step_insert_parameter}
            onChange={handleChange}
            error={
              touched["external_survey_step_insert_parameter"] &&
              !!errors["external_survey_step_insert_parameter"]
            }
            helperText={
              touched["external_survey_step_insert_parameter"] &&
              !!errors["external_survey_step_insert_parameter"]
                ? errors["external_survey_step_insert_parameter"]
                : ""
            }
          />
        </Grid>
      </Fade>
    </Grid>
  );
};
